module.exports = __webpack_public_path__ + "static/media/Mix_inicio_testigo3_opinion.59de1da4.png";